import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface DestinationGuideMatch {
  slug: string;
  name: string;
  state: string | null;
  iterpec_destination_id: string | null;
}

/**
 * Fetches published destination guides matching a search term.
 * Used by the hero search autocomplete to surface "Ver guia do destino".
 */
export const useDestinationGuides = (searchTerm: string) => {
  return useQuery({
    queryKey: ['destination-guides-search', searchTerm.trim().toLowerCase()],
    enabled: searchTerm.trim().length >= 3,
    staleTime: 5 * 60_000,
    gcTime: 15 * 60_000,
    queryFn: async (): Promise<DestinationGuideMatch[]> => {
      const q = searchTerm.trim();
      const { data, error } = await supabase
        .from('destinations')
        .select('slug, name, state, iterpec_destination_id')
        .eq('status', 'published')
        .ilike('name', `%${q}%`)
        .limit(5);
      if (error) return [];
      return (data ?? []) as DestinationGuideMatch[];
    },
  });
};
